import { render, staticRenderFns } from "./detail-component-summary.vue?vue&type=template&id=dfdeb5bc&scoped=true"
import script from "./detail-component-summary.vue?vue&type=script&lang=ts"
export * from "./detail-component-summary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfdeb5bc",
  null
  
)

export default component.exports